module.exports = __webpack_public_path__ + "img/full7-min.92937569.png";